/**
 * @file dictionary.component.tsx
 * @description Collapsed form-control компонент для работы с словарем в свернутом состоянии. Представляет собой обертку вокруг UI Dictionary компонента с возможностью сворачивания/разворачивания для экономии места в формах Task Manager. Используется для отображения справочных данных и выбора значений из предопределенного списка.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@components/ui/data/dictionary', 'react-hook-form', '@consta/uikit/Collapse', 'react']
 * @related-files ['@components/ui/data/dictionary/dictionary.component.tsx', '@components/form-controls/dictionary/dictionary.component.tsx']
 */

import { Dictionary as UIDictionary } from '@components/ui/data/dictionary';
import { Control, Controller } from 'react-hook-form';
import { Collapse } from '@consta/uikit/Collapse';
import { useState } from 'react';

/**
 * Props для collapsed form-control компонента Dictionary с интеграцией react-hook-form
 */
interface IDictionary {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
    /** CSS класс для дополнительной стилизации */
    className?: string;
    /** Ширина компонента */
    width?: string;
    /** Текст заголовка для свернутой секции */
    label: string;
}

export const Dictionary = ({ control, name, label, ...props }: IDictionary) => {
    const [isOpen, setOpen] = useState<boolean>(true);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Collapse label={label} isOpen={isOpen} onClick={() => setOpen(!isOpen)}>
                    <UIDictionary onChange={field.onChange} value={field.value} {...props} />
                </Collapse>
            )}
        />
    );
};
